import { gql } from 'graphql-request'

export default {
  createJob: gql`
    mutation createJob($job: CreateJob) {
      createJob(job: $job)
    }
  `,
}
